export const RootPrefix = 'upload_page';
